module.exports = __webpack_public_path__ + "static/media/welcome.7d30c3ea.svg";